import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { TextField } from '@/components/functional/Form/TextField';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
import { passwordResetPath } from '@/utils/router/links';
import { validatePasswordLogin } from '@/utils/validate/resources/password/login';
/**
 * ログイン画面 パスワード入力フォーム
 * @param props
 * @returns
 */
export const LoginPasswordField = (props) => {
    const { className = '', name } = props;
    return (_jsx(FieldLabel, Object.assign({ className: className, labelText: _jsxs(_Fragment, { children: [_jsx("span", { children: "\u30D1\u30B9\u30EF\u30FC\u30C9" }), _jsx(RouterLink, Object.assign({ className: 'group', to: passwordResetPath() }, { children: _jsx(LinkText, Object.assign({ isGroup: true, size: 'sm' }, { children: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F\u5834\u5408" })) }))] }), labelTextClassName: 'flex items-center justify-between w-full' }, { children: _jsx(TextField, { name: name, type: 'password', validate: validatePasswordLogin }) })));
};
